const GET_CITIES = 'GET_CITIES';
const SET_CITIES = 'SET_CITIES';
const GET_DISPOSITIONSUBCHOICECITIES = 'SET_DISPOSITIONSUBCHOICECITIES';
const SET_DISPOSITIONSUBCHOICECITIES = 'SET_DISPOSITIONSUBCHOICECITIES';

export {
    GET_CITIES,
    SET_CITIES,
    GET_DISPOSITIONSUBCHOICECITIES,
    SET_DISPOSITIONSUBCHOICECITIES
};